import React, { useState } from 'react';
import styles from '../static/styles/GamingTaskSubmitPopup.module.css';
import { submitGamingTaskEntry } from '../api/challenges';
import MessagePopup from '../components/MessagePopup';

const GamingTaskSubmitPopup = ({ isOpen, onClose, gameId, challengeId, taskImage }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null); // State for image preview
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionMessage, setSubmissionMessage] = useState(null);
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState();

  if (!isOpen) return null;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      const fileSize = file.size;

      // Validate file type (allow only png, jpg, jpeg)
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(fileType)) {
        setSubmissionMessage('Only PNG, JPG, and JPEG files are allowed.');
        setSelectedFile(null);
        setPreviewImage(null);
        return;
      }

      // Validate file size (2MB limit)
      if (fileSize > 2048000) {
        setSubmissionMessage('Image should be less than 2MB.');
        setSelectedFile(null);
        setPreviewImage(null);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setSubmissionMessage(null);
        setSelectedFile(file); // Store the file object
        setPreviewImage(reader.result); // Set the preview image (Base64 string)
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    if (!selectedFile) return;

    setIsSubmitting(true);
    setSubmissionMessage(null);

    try {
      const response = await submitGamingTaskEntry(previewImage, gameId, challengeId);

      if (response.success) {
        setPopupMessage('Image submitted successfully!');
        setShowMessagePopup(true);
        // onClose();
      } else {
        setSubmissionMessage('Failed to submit entry. Please try again.');
      }
    } catch (error) {
      setSubmissionMessage('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        <p className={styles.instruction}>
          Take a <span className={styles.highlight}>screenshot</span> of your game task & submit here
        </p>
        {taskImage && <img src={taskImage} alt="Task Preview" className={styles.uploadIcon} />}
        <div className={styles.fileInput}>
          <label htmlFor="fileUpload">Choose File</label>
          <input
            id="fileUpload"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
        {previewImage && (
          <div className={styles.previewContainer}>
            <p className={styles.previewLabel}>Image Preview:</p>
            <img src={previewImage} alt="Preview" className={styles.previewImage} />
          </div>
        )}
        {submissionMessage && <p className={styles.message}>{submissionMessage}</p>}
        <button
          className={styles.submitButton}
          onClick={handleSubmit}
          disabled={!selectedFile || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
      {showMessagePopup && (
        <MessagePopup
          isOpen={showMessagePopup}
          onClose={() => {setShowMessagePopup(false); onClose(); window.location.reload();}}
          message={popupMessage}
        />
      )}
    </div>
  );
};

export default GamingTaskSubmitPopup;